export default __webpack_public_path__ + "static/media/home_bgm.f37bcc28.mp3";